import React from 'react'
import InfoRight from './Components/InfoRight'
import "./Content.css";
import CalculatorLeft from './Components/CalculatorLeft';
const Content = () => {
  return (
    <div className='global-content'>
      <div className="container-content">
        <InfoRight/>
        <CalculatorLeft/>
      </div>
    </div>
  )
}

export default Content
